import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BsCart3, 
  BsBuilding, 
  BsHeartPulse, 
  BsHouseDoor, 
  BsMortarboard, 
  BsCupHot,
  BsArrowRight 
} from 'react-icons/bs';

const industryList = [
  {
    id: 'e-commerce',
    title: 'E-Commerce',
    icon: <BsCart3 className="text-xl" />,
    image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?auto=format&fit=crop&w=600&q=80',
    link: '/portfolio'
  },
  {
    id: 'business-corporate',
    title: 'Business & Corporate',
    icon: <BsBuilding className="text-xl" />,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=600&q=80',
    link: '/portfolio'
  },
  {
    id: 'healthcare',
    title: 'Healthcare',
    icon: <BsHeartPulse className="text-xl" />,
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=600&q=80',
    link: '/portfolio'
  },
  {
    id: 'real-estate',
    title: 'Real Estate',
    icon: <BsHouseDoor className="text-xl" />,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=80',
    link: '/portfolio'
  },
  {
    id: 'education',
    title: 'Education',
    icon: <BsMortarboard className="text-xl" />,
    image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=600&q=80',
    link: '/portfolio'
  },
  {
    id: 'food-beverage',
    title: 'Food & Beverage',
    icon: <BsCupHot className="text-xl" />,
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=600&q=80',
    link: '/portfolio'
  }
];

const Industries = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#fafbfc] text-slate-900 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Row */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          
          {/* Left: Tag & Heading */}
          <div className="space-y-3 max-w-xl" data-aos="fade-right">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-sm bg-[#f06600]"></span>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                INDUSTRIES WE SERVE
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.15]">
              Building Digital Solutions<br />
              Across <span className="text-[#f06600]">Every Industry</span>
            </h2>
          </div>

          {/* Right: Subtitle and View All Link */}
          <div className="lg:max-w-md space-y-3" data-aos="fade-left">
            <p className="text-xs sm:text-sm text-slate-500 leading-relaxed">
              We understand that every industry is unique. That's why we create customized digital solutions to meet your specific needs.
            </p>
            <Link
              to="/services"
              className="inline-flex items-center gap-1.5 text-xs font-bold text-[#f06600] hover:text-[#d05800] transition-colors"
            >
              <span>View All Industries</span>
              <BsArrowRight className="text-sm" />
            </Link>
          </div>

        </div>

        {/* 6 Industry Photo Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {industryList.map((item, idx) => (
            <Link
              key={item.id}
              to={item.link}
              className="group relative h-48 sm:h-56 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              data-aos="fade-up"
              data-aos-delay={idx * 60}
            >
              {/* Photo Background */}
              <img 
                src={item.image} 
                alt={item.title} 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              
              {/* Dark Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/20 group-hover:from-black/90 group-hover:via-black/50 transition-colors"></div>

              {/* Centered Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-3 text-center text-white z-10">
                <div className="w-10 h-10 rounded-xl bg-white/15 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white mb-2 group-hover:bg-[#f06600] group-hover:border-[#f06600] transition-all">
                  {item.icon}
                </div>
                <h3 className="text-xs sm:text-sm font-bold text-white tracking-wide group-hover:text-orange-200 transition-colors">
                  {item.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Industries;
